module.exports = __webpack_public_path__ + "src/assets/img/play.b91c01fb.png";